import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { endpoints } from '../../../api/api';
import { BookData } from './types';
import { replaceId } from './validations';

export const createBook = createAsyncThunk(
  'book/createBook',
  async (bookData: Partial<BookData>, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${endpoints.createBook}`, bookData);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to create book');
    }
  }
);

export const updateBook = createAsyncThunk(
  'book/updateBook',
  async ({ bookId, bookData }: { bookId: string; bookData: Partial<BookData> }, { rejectWithValue }) => {
    try {
      const response = await axios.put(`${replaceId(endpoints.updateBook, bookId)}`, bookData);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to update book');
    }
  }
);

export const fetchBook = createAsyncThunk(
  'book/fetchBook',
  async (bookId: string, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${replaceId(endpoints.getBook, bookId)}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch book');
    }
  }
);

export const updateBookStep = createAsyncThunk(
  'book/updateBookStep',
  async ({ bookId, currentStep }: { bookId: string; currentStep: string }, { rejectWithValue }) => {
    try {
      const response = await axios.put(`${replaceId(endpoints.updateBookStep, bookId)}`, { currentStep });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to update step');
    }
  }
);

export const submitBookForReview = createAsyncThunk(
  'book/submitForReview',
  async (bookId: string, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${replaceId(endpoints.submitBook, bookId)}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to submit book for review');
    }
  }
);
